<div class="ask-state">
  <h3 class="h-main h-main-medium corporate colapse-h" (click)="collapseAsk = !collapseAsk">
    {{ 'ask_state_title' | translate }}
    <a
      href="javascript:;"
      class="colapse-arrow"
      [ngClass]="{ 'ic-arrow-short-down': collapseAsk, 'ic-arrow-short-up': !collapseAsk }"
    ></a>
  </h3>
  <div class="next-action" [ngClass]="{ 'colapse-box colapsed': collapseAsk }">
    <div class="dashboard-card__body">
      <div class="alerts-container">
        @if (!httpError) {
          <div>
            <div *ngFor="let item of listEvents" [class]="getSeverity(item?.subType)">
              <div class="col-2 no-pd"><span [class]="getIcon(item?.type)"></span></div>
              <div class="col-10 no-pd">
                @if (getLink(item?.link) !== '') {
                  <h4>
                    <a
                      [routerLink]="getLink(item?.link)"
                      [innerHTML]="item?.summary | translate: { nameHolder: nameHolder }"
                    ></a>
                  </h4>
                }

                @if (getLink(item?.link) === '') {
                  <h4>
                    <span [innerHTML]="item?.summary | translate: { nameHolder: nameHolder }"></span>
                  </h4>
                }

                @if (translateService.instant(item?.detail).trim()) {
                  <span class="more-info"
                    ><a href="javascript:;" title="" (click)="showEventDetails(item)">{{
                      item.showDetails ? '-' : '+'
                    }}</a></span
                  >
                }
              </div>
              <div class="col-12 no-pd" [ngStyle]="{ display: item.showDetails ? 'block' : 'none' }">
                <div class="next-action-info">
                  <p [innerHTML]="item?.detail | translate: { nameHolder: nameHolder }"></p>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- en caso de error: -->
        @if (httpError) {
          <div>
            <div class="col-12">
              <h4 class="text-center has-error">{{ 'ask_state_msg' | translate }}</h4>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="contact-info row">
      <div class="col-2 no-pd">
        <span class="ic ic-talk-men"></span>
      </div>
      <div class="col-10 row">
        <div class="col-12">
          <p class="sat-tel">{{ agentData?.phone | translate }}</p>
        </div>
        <div class="col-12">
          <a
            href="javascript:void(0)"
            [routerLink]="wallUrl"
            [title]="'ask_state_write_your_manager_title' | translate"
          >
            {{ 'ask_state_write_your_manager' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
